import { createRoute, lazyRouteComponent } from '@tanstack/react-router'

import { guardRoute } from '../../auth/guard.ts'
import { parseOnboardingStep, type OnboardingSearch } from '../../data/club-onboarding.ts'
import { NAV_PATHS } from '../../navigation/paths.ts'
import { rootRoute } from '../root.tsx'

// The import of the tabulato: a page of its own, a flow with its bar at the foot, which keeps the
// `onboarding` of the guide on its way to «Componi le rose» without drawing the guide's bar.

export const officialTabulatoRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: NAV_PATHS.officialTabulato,
  validateSearch: (search: Record<string, unknown>): OnboardingSearch => ({
    onboarding: parseOnboardingStep(search.onboarding),
  }),
  beforeLoad: ({ context, location }) =>
    guardRoute({
      queryClient: context.queryClient,
      requiredRoles: ['club'],
      currentPath: location.href,
    }),
  staticData: { chrome: 'flow', opensOnHero: true },
  component: lazyRouteComponent(() => import('../../pages/official/tabulato.tsx')),
})

export const officialTabulatoLink = { to: NAV_PATHS.officialTabulato } as const
